import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from 'react';
import {Button, Grid, Paper, Stack, TextField, Typography} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Box from '@mui/material/Box';
import api from '../../services/api';
import {
  DataGridPro,
  GridColDef,
} from '@mui/x-data-grid-pro';
import { styled } from '@mui/material/styles';
import NoRowsOverlay from '../Table/NoRowsOverLay';
import {debounce} from 'lodash';
import toast from "react-hot-toast";
import Tooltip from "@mui/material/Tooltip";
import {IosShareRounded} from "@mui/icons-material";
import {PaperProps} from "@mui/material/Paper";
import Draggable from "react-draggable";
import {v4 as uuidv4} from "uuid";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '& .no-rows-primary': {
    fill: '#3D4751',
    ...theme.applyStyles('light', {
      fill: '#AEB8C2',
    }),
  },
  '& .no-rows-secondary': {
    fill: '#1D2126',
    ...theme.applyStyles('light', {
      fill: '#E8EAED',
    }),
  },
}));

function CustomNoRowsOverlay() {
  return (
    <StyledGridOverlay>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        width={96}
        viewBox="0 0 452 257"
        aria-hidden
        focusable="false"
      >
        <path
          className="no-rows-primary"
          d="M348 69c-46.392 0-84 37.608-84 84s37.608 84 84 84 84-37.608 84-84-37.608-84-84-84Zm-104 84c0-57.438 46.562-104 104-104s104 46.562 104 104-46.562 104-104 104-104-46.562-104-104Z"
        />
        <path
          className="no-rows-primary"
          d="M308.929 113.929c3.905-3.905 10.237-3.905 14.142 0l63.64 63.64c3.905 3.905 3.905 10.236 0 14.142-3.906 3.905-10.237 3.905-14.142 0l-63.64-63.64c-3.905-3.905-3.905-10.237 0-14.142Z"
        />
        <path
          className="no-rows-primary"
          d="M308.929 191.711c-3.905-3.906-3.905-10.237 0-14.142l63.64-63.64c3.905-3.905 10.236-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142l-63.64 63.64c-3.905 3.905-10.237 3.905-14.142 0Z"
        />
        <path
          className="no-rows-secondary"
          d="M0 10C0 4.477 4.477 0 10 0h380c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 20 0 15.523 0 10ZM0 59c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 69 0 64.523 0 59ZM0 106c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 153c0-5.523 4.477-10 10-10h195.5c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 200c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 247c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10Z"
        />
      </svg>
      <Box sx={{ mt: 2 }}>No rows</Box>
    </StyledGridOverlay>
  );
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));
export const GuideOptions = ({
  handleClose,
  row,
  schema,
}: {
  handleClose: () => void;
  row: any;
  schema: any;
}): ReactElement => {
  const [loadingRows, setLoadingRows] = useState<any>(false);
  const [loadingGuideRows, setLoadingGuideRows] = useState<any>(false);
  const [guideRows, setGuideRows] = useState<any>({
    available: [],
    available_in_weekend: [],
    unavailable: []
  });
  const [activityReservations, setActivityReservations] = useState<any>([]);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [puffers, setPuffers] = useState<any>({
    startPuffer: 0,
    endPuffer: 0,
  });
  const [rowSelectionModel, setRowSelectionModel] = useState<any>([]);

  const fetchData = useCallback(() => {
    setLoadingRows(true);
    if (schema?.viewTable === 'groups') {
      api.get(`/groups/${row?.id}/activity-reservations`).then((res: any) => {
        const filtered = res.filter((item: any) => item.id !== 'SUM');
        setActivityReservations(filtered);
        setLoadingRows(false);
      });
    } else {
      api.get(`/activity-reservations/${row?.id}`).then((res: any) => {
        setActivityReservations([res]);
        setLoadingRows(false);
      });
    }
  }, [schema]);

  const fetchLastMinuteGuideOptions = useCallback(() => {
    setLoadingGuideRows(true);

    api
      .post(`/activity-reservations/available-last-minute-guides/${selectedRow?.id}`, {
        puffers: puffers,
      })
      .then((res: any) => {
        setGuideRows(res);
        setLoadingRows(false);

        if (res?.errors){
          res.errors.map((message: any) => {
            toast.error(message)
          });
        }
      })
      .finally(() => {
        setLoadingGuideRows(false);
      });
  }, [schema, selectedRow, puffers]);

  useEffect(() => {
    fetchData();
  }, []);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'pickup_time', headerName: 'Pickup', width: 70 },
    { field: 'start_time', headerName: 'Start', width: 70 },
  ];

  const columnsForGuide: GridColDef[] = [
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'before',
      headerName: 'Before Activity',
      flex: 1,
      renderCell: (params) =>{
        return !params.value ? '' : `${params.value?.activity_reservation_name}`;
      }
    },
    { field: 'before_date',
      headerName: 'Date',
      width: 220,
      renderCell: (params) =>{
        return <>
          <Stack direction={'row'} gap={1}>
            <Stack>
              <p>{params.row?.before?.start}</p>
            </Stack>
            <p>-</p>
            <Stack>
              <p>{params.row?.before?.end}</p>
            </Stack>
          </Stack>
        </>;
      }
    },

    { field: 'after',
      headerName: 'After Activity',
      flex: 1,
      renderCell: (params) =>{
        return !params.value ? '' : `${params.value?.activity_reservation_name}`;
      }
    },
    { field: 'after_date',
      headerName: 'Date',
      width: 220,
      renderCell: (params) =>{
        return <>
          <Stack direction={'row'} gap={1}>
            <Stack>
              <p>{params.row?.after?.start}</p>
            </Stack>
            <p>-</p>
            <Stack>
              <p>{params.row?.after?.end}</p>
            </Stack>
          </Stack>
        </>;
      }
    },
    {
      field: 'actions',
      headerName: '#',
      width: 50,
      editable: false,
      renderCell: (props: any) => {
        return (
          <>
            <Stack direction={'row'}>
              <Tooltip title={'Assignment to Activity'}>
                <IconButton>
                  <IosShareRounded
                    color={'primary'}
                    onClick={() => {
                      handleAssignment(props.row);
                    }}
                  />
                </IconButton>
              </Tooltip>
            </Stack>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (activityReservations.length > 0) {
      const firstRowId = activityReservations[0].id;
      setRowSelectionModel([firstRowId]);
      setSelectedRow(activityReservations[0]);
    }
  }, [activityReservations]);

  const handleSubmit = () => {

    if (!selectedRow){
      toast.error('Select activity');
      return;
    }

    fetchLastMinuteGuideOptions();
  }

  useEffect(() => {
    if(selectedRow){
      handleSubmit();
    }
  }, [selectedRow]);

  const handleAssignment = (row:any) => {

    if (!selectedRow){
      toast.error('Select activity');
      return;
    }

    api
      .post(`/activity-reservations/available-last-minute-guides/${selectedRow?.id}/${row?.guide_id}`, {})
      .then((res: any) => {
        toast.success('Successfully save');
      })
      .catch(() => {
        toast.error('Error while save');
      })
      .finally(()=>{
        fetchLastMinuteGuideOptions();
    });

  }

  const draggablePaneId = useMemo(() => {
    return `draggable-responsive-add-new-dialog-${uuidv4()}`;
  }, []);

  const PaperComponent = useCallback(
    (props: PaperProps) => {
      return (
        <Draggable
          handle={`#${draggablePaneId}`}
          cancel={'[class*="MuiDialogContent-root"], .non-draggable-button'}
        >
          <Paper {...props} />
        </Draggable>
      );
    },
    []
  );

  return (
    <>
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{
          '& .MuiPaper-root.MuiDialog-paper': {
            maxWidth: 'calc(100% - 180px)',
            height: 'calc(100% - 100px)',
            background: '#f3f3f3',
          },
        }}
      >
        <AppBar
          sx={{
            position: 'relative',
            background: '#256861',
          }}
        >
          <Toolbar
            id={draggablePaneId}
          >
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {`${row?.name} - Guide Options`}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box
          sx={{
            p: '20px',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <Item>
                <DataGridPro
                  columnHeaderHeight={30}
                  loading={loadingRows}
                  rows={activityReservations}
                  columns={columns}
                  pageSizeOptions={[100]}
                  getRowHeight={() => 30}
                  rowSelection={true}
                  rowSelectionModel={rowSelectionModel}
                  onRowSelectionModelChange={(newSelection:any) => {
                    setRowSelectionModel(newSelection);
                    const selected = activityReservations.find((r:any) => r.id === newSelection[0]);
                    setSelectedRow(selected || null);
                  }}
                  onRowClick={(params:any) => {
                    setSelectedRow(params.row);
                    setRowSelectionModel([params.id]);
                  }}
                />
              </Item>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Item>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={3}>
                    <TextField
                      fullWidth={true}
                      type={'number'}
                      label="Start Puffer"
                      variant="outlined"
                      value={puffers.startPuffer}
                      onChange={(event) =>
                        setPuffers({
                          ...puffers,
                          startPuffer: event.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <TextField
                      fullWidth={true}
                      type={'number'}
                      label="End Puffer"
                      variant="outlined"
                      value={puffers.endPuffer}
                      onChange={(event) =>
                        setPuffers({
                          ...puffers,
                          endPuffer: event.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <TextField
                      fullWidth
                      type={'time'}
                      label="Start Time"
                      variant="outlined"
                      disabled
                      defaultValue={row?.start_time}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    {activityReservations[0] ? (
                      <TextField
                        fullWidth
                        type={'time'}
                        label="End Time"
                        variant="outlined"
                        disabled
                        defaultValue={activityReservations[0]?.end_time}
                      />
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              </Item>
            </Grid>

            <Grid item xs={12}>
              <Item>
                <Typography>Dolgozik aznap és ráér:</Typography>
                <DataGridPro
                  hideFooter={true}
                  columnHeaderHeight={30}
                  loading={loadingGuideRows}
                  rows={guideRows?.available}
                  columns={columnsForGuide}
                  pageSizeOptions={[100]}
                  getRowHeight={() => 30}
                  autoHeight
                  slots={{
                    // @ts-ignore
                    noRowsOverlay: NoRowsOverlay,
                  }}
                  sx={{ '--DataGrid-overlayHeight': '100px' }}
                />
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item>
                <Typography>Dolgozik a hétvégén és ráér:</Typography>
                <DataGridPro
                  hideFooter={true}
                  columnHeaderHeight={30}
                  loading={loadingGuideRows}
                  rows={guideRows?.available_in_weekend}
                  columns={columnsForGuide}
                  pageSizeOptions={[100]}
                  getRowHeight={() => 30}
                  autoHeight
                  slots={{
                    // @ts-ignore
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  sx={{ '--DataGrid-overlayHeight': '100px' }}
                />
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item>
                <Typography>Dolgozik aznap és nem ér rá:</Typography>
                <DataGridPro
                  hideFooter={true}
                  columnHeaderHeight={30}
                  loading={loadingGuideRows}
                  rows={guideRows?.unavailable}
                  columns={columnsForGuide}
                  pageSizeOptions={[100]}
                  getRowHeight={() => 30}
                  autoHeight
                  slots={{
                    // @ts-ignore
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  sx={{ '--DataGrid-overlayHeight': '100px' }}
                />
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item>
                <Button
                  onClick={() => handleSubmit()}
                  variant={'contained'}
                >
                  Submit
                </Button>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </>
  );
};
